export const ACTIONS = {
  CREATE: 'Create',
  DELETE: 'Delete',
  DELETE_FROM_MAP: 'DeleteFromMap',
  EDIT_FROM_MAP: 'EditFromMap',
  EDIT: 'Edit',
  LOAD: 'Load',
  LOAD_PAGINATION: 'LoadPagination',
  TOGGLE_STATUS: 'ToggleStatus',
};

export const GETTERS = {
  DATA: 'Data',
  FILTERED_DATA: 'FilteredData',
  IS_LOADING: 'IsLoading',
  TOTAL_PAGINATED_DATA: 'TotalPaginatedData',
};

export const MUTATIONS = {
  SET_DATA: 'SetData',
  SET_IS_LOADING: 'SetIsLoading',
  SET_TOTAL_PAGINATED_DATA: 'SetTotalPaginatedData',
  RESET: 'Reset',
};

export const ROLES = {
  BRANCH_MANAGER: 'BRANCH_MANAGER',
  BRANCH_DISTRIBUTION_MANAGER: 'BRANCH_DISTRIBUTION_MANAGER',
  BRANCH_VIEWER: 'BRANCH_VIEWER',
  CAXTON_SALES_USER: 'CAXTON_SALES_USER',
  DATA_CAPTURER: 'DATA_CAPTURER',
  DROPSHEET_MANAGER: 'DROPSHEET_MANAGER',
  SPARK_SALES_USER: 'SPARK_SALES_USER',
  SUPER_USER: 'SUPER_USER',
  SUPER_ADMINISTRATOR: 'SUPER_ADMINISTRATOR',
};

export const STATUSES = {
  APPROVED: 'Approved',
  PENDING: 'Pending',
  DECLINED: 'Declined',
};

export const STATE_VARS = {
  DATA: 'data',
  IS_LOADING: 'isLoading',
  TOTAL_PAGINATED_DATA: 'TotalPaginatedData',
};

export const AccountTypesStore = {
  Name: 'accountTypesStore',
};

export const AddressSearchStore = {
  Actions: {
    AddressSearch: 'AddressSearch',
    DoAutocomplete: 'DoAutocomplete',
    DoSearch: 'DoSearch',
    DoSearchDetails: 'DoSearchDetails',
    DoSublocalityAutocomplete: 'DoSublocalityAutocomplete',
    SearchLastEnteredText: 'SearchLastEnteredText',
    ReverseGeocode: 'ReverseGeocode',
  },
  Getters: {
    AxiosInstance: 'AxiosInstance',
    AxiosAutocompleteSource: 'AxiosAutocompleteSource',
    DetailedResults: 'DetailedResults',
    LastEnteredText: 'LastEnteredText',
    SearchErrorMessage: 'SearchErrorMessage',
    ReverseGeocodeResult: 'ReverseGeocodeResult',
    IsLoadingReverseGeocode: 'IsLoadingReverseGeocode',
  },
  Mutations: {
    CancelAxiosAutocompleteSource: 'CancelAxiosAutocompleteSource',
    SetAxiosAutocompleteSource: 'SetAxiosAutocompleteSource',
    SetAxiosInstance: 'SetAxiosInstance',
    SetDetailedResults: 'SetDetailedResults',
    SetLastEnteredText: 'SetLastEnteredText',
    SetSearchErrorMessage: 'SetSearchErrorMessage',
    SetReverseGeocodeResult: 'SetReverseGeocodeResult',
    SetIsLoadingReverseGeocode: 'SetIsLoadingReverseGeocode',
  },
  Name: 'addressSearchStore',
  StateVars: {
    AxiosInstance: 'axiosInstance',
    AxiosAutocompleteSource: 'axiosAutocompleteSource',
    DetailedResults: 'detailedResults',
    LastEnteredText: 'lastEnteredText',
    SearchErrorMessage: 'searchErrorMessage',
    ReverseGeocodeResult: 'ReverseGeocodeResult',
    IsLoadingReverseGeocode: 'isLoadingReverseGeocode',
  },
};

export const AddressSelectorStore = {
  Name: 'addressSelectorStore',
};

export const AuthorisationStore = {
  Getters: {
    AllowedMenuItems: 'AllowedMenuItems',
    IsAllowedToAccessRoute: 'AllowedToAccessRoute',
    IsOffline: 'IsOffline',
    LogOutUrl: 'LogoutUrl',
    Role: 'Role',
    Token: 'Token',
    User: 'User',
  },
  Mutations: {
    ClearToken: 'ClearToken',
    ClearUser: 'ClearUser',
    SetIsOffline: 'SetIsOffline',
    SetKeycloak: 'SetKeyCloak',
    SetToken: 'SetToken',
  },
  Name: 'authorisationStore',
};

export const AwsAxiosStore = {
  Actions: {
    LoadAwsAuthentication: 'LoadAwsAuthentication',
  },
  Mutations: {
    SetToken: 'SetToken',
    SetKey: 'SetKey',
    SetTokenRefreshStrategy: 'SetTokenRefreshStrategy',
  },
  Name: 'awsAxiosStore',
  StateVars: {
    Instance: 'instance',
    Key: 'key',
    Token: 'token',
    TokenRefreshStrategy: 'TokenRefreshStrategy',
  },
};

export const BulkFreePublicationDropsheetReportSummaryStore = {
  Actions: {
    LoadDetailed: 'LoadDetailed',
  },
  Getters: {
    IsPrinting: 'IsPrinting',
    HasData: 'HasData',
  },
  Mutations: {
    SetIsPrinting: 'SetIsPrinting',
  },
  Name: 'bulkFreePublicationDropsheetReportSummaryStore',
  StateVars: {
    IsPrinting: 'IsPrinting',
  },
};

export const BulkDropTypesStore = {
  Actions: {
    EditIsDisabled: 'EditIsDisabled',
  },
  Getters: {
    FilterForType: 'FilterForType',
    Types: 'Types',
  },
  Mutations: {
    SetFilterForType: 'SetFilterForType',
  },
  Name: 'bulkDropTypesStore',
  StateVars: {
    FilterForType: 'FilterForType',
    Types: 'Types',
  },
};

export const BulkDropTypeLookupsStore = {
  Name: 'bulkDropTypeLookupsStore',
};

export const BundleStore = {
  Name: 'bundleStore',
};

export const BranchesStore = {
  Name: 'branchesStore',
};

export const BranchInfoDropDownStore = {
  Getters: {
    BranchId: 'BranchId',
    PublicationId: 'PublicationId',
  },
  Mutations: {
    SetBranchId: 'SetBranchId',
    SetPublicationId: 'SetPublicationId',
  },
  Name: 'branchInfoDropDownsStore',
  StateVars: {
    BranchId: 'BranchId',
    PublicationId: 'PublicationId',
  },
};

export const ComplaintsAndRequestsStore = {
  Actions: {
    LoadDetails: 'LoadDetails',
    LoadByAttributes: 'LoadByAttributes',
  },
  Getters: {
    Details: 'Details',
    FilterForPublication: 'FilterForPublication',
    FilterForCaptureModeType: 'FilterForCaptureModeType',
    FilterForStatusType: 'FilterForStatusType',
    IsDetailsLoading: 'IsDetailsLoading',
    LastSearchedPayload: 'LastSearchedPayload',
    FromDate: 'FromDate',
    ToDate: 'ToDate',
    Types: 'Types',
  },
  Mutations: {
    SetDetails: 'SetDetails',
    SetFilterForPublication: 'SetFilterForPublication',
    SetPublicationLookup: 'SetPublicationLookup',
    SetCaptureModeTypeLookup: 'SetCaptureModeTypeLookup',
    SetFilterForCaptureModeType: 'SetFilterForCaptureModeType',
    SetFilterForStatusType: 'SetFilterForStatusType',
    SetIsDetailsLoading: 'SetIsDetailsLoading',
    SetLastSearchedPayload: 'SetLastSearchedPayload',
    SetFromDate: 'SetFromDate',
    SetToDate: 'SetToDate',
    SetTypes: 'SetTypes',
  },
  Name: 'complaintsAndRequestsStore',
  StateVars: {
    Details: 'Details',
    PublicationLookup: 'publicationLookup',
    FilterForPublication: 'filterForPublication',
    CaptureModeTypeLookup: 'captureModeTypeLookup',
    FilterForCaptureModeType: 'filterForCaptureModeType',
    FilterForStatusType: 'filterForStatusType',
    IsDetailsLoading: 'isDetailsLoading',
    LastSearchedPayload: 'LastSearchedPayload',
    FromDate: 'fromDate',
    ToDate: 'toDate',
    Types: 'types',
  },
};

export const ComplaintsFormDistributionQueryStore = {
  Actions: {
    UploadFile: 'UploadFile',
  },
  Getters: {
    IsDownloading: 'IsDownloading',
  },
  Mutations: {
    SetIsDownloading: 'SetIsDownloading',
  },
  Name: 'complaintsFormDistributionQueryStore',
  StateVars: {
    IsDownloading: 'isDownloading',
  },
};

export const ComplaintsFormDistributionResponseStore = {
  Actions: {
    UploadFile: 'UploadFile',
  },
  Getters: {
    IsDownloading: 'IsDownloading',
  },
  Mutations: {
    SetIsDownloading: 'SetIsDownloading',
  },
  Name: 'complaintsFormDistributionResponseStore',
  StateVars: {
    IsDownloading: 'isDownloading',
  },
};

export const CaxtonOfficeStore = {
  Name: 'caxtonOfficeStore',
};

export const CompetitorIconsStore = {
  Name: 'competitorIconsStore',
};

export const ComplaintRequestFormsHistoryStore = {
  Getters: {
    LoadSource: 'LoadSource',
  },
  Mutations: {
    CancelLoadSource: 'CancelLoadSource',
    SetLoadSource: 'SetLoadSource',
  },
  Name: 'complaintRequestFormsHistoryStore',
  StateVars: {
    LoadSource: 'loadSource',
  },
};

export const ComplaintFormStatusStore = {
  Name: 'complaintFormStatusStore',
};
export const CrudModuleStore = {
  Getters: {
    ColumnFields: 'ColumnFields',
  },
};

export const CustomLayerStore = {
  Name: 'customLayerStore',
};

export const ConfiguredCustomLayersStore = {
  Getters: {
    HydratedLayers: 'HydratedLayers',
  },
  Name: 'configuredCustomLayersStore',
};

export const DeliveryMethodsStore = {
  Name: 'deliveryMethodsStore',
};

export const DistributionCountsStore = {
  Actions: {
    LoadDistributionCountsDetails: 'LoadDistributionCountsDetails',
  },
  Getters: {
    ColumnFields: 'ColumnFields',
    Details: 'Details',
    IsDetailsLoading: 'IsDetailsLoading',
    Notification: 'Notification',
  },
  Mutations: {
    SetDetails: 'SetDetails',
    SetIsDetailsLoading: 'SetIsDetailsLoading',
    SetNotification: 'SetNotification',
  },
  Name: 'distributionCountsStore',
  StateVars: {
    ColumnFields: 'ColumnFields',
    Details: 'Details',
    IsDetailsLoading: 'IsDetailsLoading',
    Notification: 'Notification',
  },
};

export const DistributionCentersStore = {
  Name: 'distributionCentersStore',
};

export const DriverAreaStore = {
  Name: 'driverAreaStore',
};

export const DropsheetDriversStore = {
  Name: 'dropsheetDriversStore',
};

export const DriversStore = {
  Name: 'driversStore',
};

export const FormApplicationLoginAudit = {
  Name: 'formApplicationLoginAudit',
};

export const FreePublicationFormConfirmationLetterStore = {
  Actions: {
    ExportAll: 'ExportAll',
  },
  Getters: {
    ExportErrorMessage: 'ExportErrorMessage',
    IsDownloading: 'IsDownloading',
    IsDeleting: 'IsDeleting',
  },
  Mutations: {
    SetExportErrorMessage: 'SetExportErrorMessage',
    SetIsDownloading: 'SetIsDownloading',
    SetIsDeleting: 'SetIsDeleting',
  },
  Name: 'freePublicationFormConfirmationLetterStore',
  StateVars: {
    ExportErrorMessage: 'ExportErrorMessage',
    IsDownloading: 'IsDownloading',
    IsDeleting: 'IsDeleting',
  },
};

export const FormImageStore = {
  Name: 'formImageStore',
};

export const FormCaptureModesStore = {
  Name: 'formCaptureModesStore',
};

export const FormsMsisdnStore = {
  Name: 'formsMsisdnStore',
};

export const FreePublicationsFormsStore = {
  Actions: {
    Capture: 'Capture',
    LoadDetails: 'LoadDetails',
    LoadDetailsByFormId: 'LoadDetailsByFormId',
    LoadByAttributes: 'LoadByAttributes',
    DownLoadExcel: 'DownLoadExcel',
  },
  Getters: {
    Details: 'Details',
    FilterForDrivers: 'FilterForDrivers',
    FilterForPublication: 'FilterForPublication',
    FromDate: 'FromDate',
    ToDate: 'ToDate',
    IsLoadingDetails: 'IsLoadingDetails',
    FilterForStatusType: 'FilterForStatusType',
    LastSearchedPayload: 'LastSearchedPayload',
    DownloadMessage: 'DownloadMessage',
    ReloadLayers: 'ReloadLayers',
  },
  Mutations: {
    SetDetails: 'SetDetails',
    SetIsLoadingDetails: 'SetIsLoadingDetails',
    SetFilterForDrivers: 'SetFilterForDrivers',
    FilterForDrivers: 'FilterForDrivers',
    SetDriversLookup: 'SetDriversLookup',
    FilterForPublication: 'FilterForPublication',
    SetFilterForPublication: 'SetFilterForPublication',
    SetFilterForStatusType: 'SetFilterForStatusType',
    SetPublicationLookup: 'SetPublicationLookup',
    SetFromDate: 'SetFromDate',
    SetToDate: 'SetToDate',
    SetLastSearchedPayload: 'SetLastSearchedPayload',
    SetDownloadMessage: 'SetDownloadMessage',
    SetReloadLayers: 'SetReloadLayers',
  },
  Name: 'freePublicationsFormsStore',
  StateVars: {
    Details: 'Details',
    FilterForDrivers: 'filterForDrivers',
    FilterForPublication: 'filterForPublication',
    FilterForStatusType: 'FilterForStatusType',
    DriversLookup: 'driversLookup',
    PublicationLookup: 'publicationLookup',
    IsLoadingDetails: 'IsLoadingDetails',
    FromDate: 'FromDate',
    ToDate: 'ToDate',
    ReloadLayers: 'ReloadLayers',
    LastSearchedPayload: 'LastSearchedPayload',
    DownloadMessage: 'DownloadMessage',
  },
};

export const FreePublicationFormImagesStore = {
  Actions: {
    LoadById: 'LoadById',
    UploadFile: 'UploadFile',
  },
  Getters: {
    FormImage: 'FormImage',
  },
  Mutations: {
    SetFormImage: 'SetFormImage',
  },
  Name: 'freePublicationFormImagesStore',
  StateVars: {
    FormImage: 'formImage',
  },
};

export const FreePublicationFormsHistoryAuditStore = {
  Getters: {
    LoadSource: 'LoadSource',
  },
  Mutations: {
    CancelLoadSource: 'CancelLoadSource',
    SetLoadSource: 'SetLoadSource',
  },
  Name: 'freePublicationFormsHistoryAuditStore',
  StateVars: {
    LoadSource: 'loadSource',
  },
};

export const FreePublicationFormStatusStore = {
  Name: 'freePublicationFormStatusStore',
};

export const FootprintsStore = {
  Name: 'footprintsStore',
};

export const FormActionsStore = {
  Name: 'formActionsStore',
};

export const LoadQuantitiesStore = {
  Getters: {
    FilterForDriver: 'FilterForDriver',
    FilterForPublication: 'FilterForPublication',
  },
  Mutations: {
    SetFilterForDriver: 'SetFilterForDriver',
    SetFilterForPublication: 'SetFilterForPublication',
    SetDriverLookup: 'SetDriverLookup',
    SetPublicationLookup: 'SetPublicationLookup',
  },
  StateVars: {
    DriverLookup: 'DriverLookup',
    FilterForDriver: 'FilterForDriver',
    FilterForPublication: 'FilterForPublication',
    PublicationLookup: 'PublicationLookup',
  },
  Name: 'loadQuantitiesStore',
};

export const MapCensusStore = {
  Name: 'mapCensusStore',
  Getters: {
    Categories: 'Categories',
  },
};

export const MapStore = {
  Getters: {
    BaseTypes: 'BaseTypes',
    Center: 'Center',
    Coordinate: 'Coordinate',
    CoordinateInfo: 'CoordinateInfo',
    CountryBoundingBox: 'CountryBoundingBox',
    InfoLayer: 'InfoLayer',
    IsInfoingOn: 'IsInfoingOn',
    IsLoadingCoordinateInfo: 'IsLoadingCoordinateInfo',
    SelectedBaseType: 'SelectedBaseType',
    SelectedId: 'SelectedId',
    SelectedLayers: 'SelectedLayers',
    ZoomLevel: 'ZoomLevel',
  },
  Mutations: {
    SetCoordinate: 'SetCoordinate',
    SetCoordinateInfo: 'SetCoordinateInfo',
    SetInfoLayers: 'SetInfoLayers',
    SetIsLoadingCoordinateInfo: 'SetIsLoadingCoordinateInfo',
    SetSelectedBaseType: 'SetSelectedBaseType',
    SetSelectedLayers: 'SetSelectedLayers',
    SetZoomLevel: 'SetZoomLevel',
    ToggleInfoFunction: 'ToggleInfoFunction',
  },
  Name: 'mapStore',
};

export const MapRegionStore = {
  Actions: {
    Update: 'Update',
  },
  Getters: {
    IsOnRegionSelectMode: 'IsOnRegionSelectMode',
    IsSelectingRegion: 'IsSelectingRegion',
  },
  Mutations: {
    SetIsOnRegionSelectMode: 'SetIsOnRegionSelectMode',
    SetIsSelectingRegion: 'SetIsSelectingRegion',
    ToggleInfo: 'ToggleInfo',
  },
  StateVars: {
    IsOnRegionSelectMode: 'IsOnRegionSelectMode',
    IsSelectingRegion: 'IsSelectingRegion',
    IsInfoingOn: 'IsInfoingOn',
  },
  Name: 'mapRegionStore',
};

export const MapSublocalitiesStore = {
  Name: 'mapSublocalitiesStore',
};

export const PublicationLogoImageStore = {
  Actions: {
    UploadFile: 'UploadFile',
    LoadByPublicationId: 'LoadByPublicationId',
  },
  Getters: {
    HasLogoImage: 'HasLogoImage',
  },
  Mutations: {
    SetHasLogoImage: 'SetHasLogoImage',
  },
  Name: 'publicationLogoImageStore',
  StateVars: {
    HasLogoImage: 'HasLogoImage',
  },
};

export const PoiCategorizationStore = {
  Getters: {
    CategoryPayload: 'CategoryPayload',
    CanSelectType3: 'CanSelectType3',

    // payload
    Category: 'Category',
    Type1: 'Type1',
    Type2: 'Type2',
    Type3: 'Type3',

    Notification: 'Notification',

    // options
    CategoryOptions: 'CategoryOptions',
    Type1Options: 'Type1Options',
    Type2Options: 'Type2Options',
    Type3Options: 'Type3Options',
  },
  Mutations: {
    SetCanSelectType3: 'SetCanSelectType3',
    SetCategory: 'SetCategory',
    SetCategoryOptions: 'SetCategoryOptions',
    SetNotification: 'SetNotification',
    SetType1: 'SetType1',
    SetType2: 'SetType2',
    SetType3: 'SetType3',
  },
  Name: 'poiCategorizationStore',
  StateVars: {
    Category: 'Category',
    CategoryOptions: 'CategoryOptions',
    Notification: 'Notification',
    Type1: 'Type1',
    Type2: 'Type2',
    Type3: 'Type3',
    Type1Options: 'Type1Options',
    Type2Options: 'Type2Options',
    Type3Options: 'Type3Options',
  },
};

export const SalesPointsStore = {
  Actions: {
    BulkUpload: 'BulkUpload',
    LoadPointData: 'LoadPointData',
    LoadCustomerPointsData: 'LoadCustomerPointsData',
    GetPointDetails: 'GetPointDetails',
  },
  Getters: {
    ColumnFields: 'ColumnFields',
    CustomerPointsData: 'CustomerPointsData',
    IsLoadingCustomerPointsData: 'IsLoadingCustomerPointsData',
    Details: 'Details',
    FilterForApprovalStatus: 'FilterForApprovalStatus',
    FilterForCategory: 'FilterForCategory',
    FilterForPublication: 'FilterForPublication',
    FilterForStatus: 'FilterForStatus',
    FilterForType1: 'FilterForType1',
    FilterForType2: 'FilterForType2',
    FilterForType3: 'FilterForType3',
    Notification: 'Notification',
  },
  Mutations: {
    SetDetails: 'SetDetails',
    SetCustomerPointsData: 'SetCustomerPointsData',
    SetIsLoadingCustomerPointsData: 'SetIsLoadingCustomerPointsData',
    SetFilterForCategory: 'SetFilterForCategory',
    SetFilterForApprovalStatus: 'SetFilterForApprovalStatus',
    SetFilterForPublication: 'SetFilterForPublication',
    SetFilterForStatus: 'SetFilterForStatus',
    SetFilterForType1: 'SetFilterForType1',
    SetFilterForType2: 'SetFilterForType2',
    SetFilterForType3: 'SetFilterForType3',
    SetNotification: 'SetNotification',
  },
  Name: 'salesPointsStore',
  StateVars: {
    ColumnFields: 'ColumnFields',
    CustomerPointsData: 'CustomerPointsData',
    IsLoadingCustomerPointsData: 'IsLoadingCustomerPointsData',
    Details: 'Details',
    FilterForApprovalStatus: 'FilterForApprovalStatus',
    FilterForCategory: 'FilterForCategory',
    FilterForPublication: 'FilterForPublication',
    FilterForStatus: 'FilterForStatus',
    FilterForType1: 'FilterForType1',
    FilterForType2: 'FilterForType2',
    FilterForType3: 'FilterForType3',
    Notification: 'Notification',
  },
};

export const SalesPointCategorizationStore = {
  Getters: {
    CategoryPayload: 'CategoryPayload',
    CanSelectType3: 'CanSelectType3',

    // payload
    Category: 'Category',
    Type1: 'Type1',
    Type2: 'Type2',
    Type3: 'Type3',

    Notification: 'Notification',

    // options
    CategoryOptions: 'CategoryOptions',
    Type1Options: 'Type1Options',
    Type2Options: 'Type2Options',
    Type3Options: 'Type3Options',
  },
  Mutations: {
    SetCanSelectType3: 'SetCanSelectType3',
    SetCategory: 'SetCategory',
    SetCategoryOptions: 'SetCategoryOptions',
    SetNotification: 'SetNotification',
    SetType1: 'SetType1',
    SetType2: 'SetType2',
    SetType3: 'SetType3',
  },
  Name: 'salesPointCategorizationStore',
  StateVars: {
    Category: 'Category',
    CategoryOptions: 'CategoryOptions',
    Notification: 'Notification',
    Type1: 'Type1',
    Type2: 'Type2',
    Type3: 'Type3',
    Type1Options: 'Type1Options',
    Type2Options: 'Type2Options',
    Type3Options: 'Type3Options',
  },
};

export const SalesLayersStore = {
  Actions: {
    LoadFootprintFilters: 'LoadFootprintFilters',
  },
  Getters: {
    FootprintFilters: 'FootprintFilters',
    FootprintMapBoundingBox: 'FootprintMapBoundingBox',
    IsFootprintsLoading: 'IsFootprintsLoading',
    IsLayersOn: 'IsLayersOn',
    IsPointOfInterestOn: 'IsPointOfInterestOn',
    IsQueryingOn: 'IsQueryingOn',
    Layers: 'Layers',
    PointCoordinates: 'PointCoordinates',
    QueryablePointInfo: 'QueryablePointInfo',
    QueryLayer: 'QueryLayer',
    SalesSelectedLayers: 'SalesSelectedLayers',
    SelectedFootprintFilters: 'SelectedFootprintFilters',
    SelectedLayers: 'SelectedLayers',
    SelectedMarkerInfo: 'SelectedMarkerInfo',
  },
  Mutations: {
    SetIsFootprintsLoading: 'SetIsFootprintsLoading',
    SetFootprintFilters: 'SetFootprintFilters',
    SetFootprintMapBoundingBox: 'SetFootprintMapBoundingBox',
    SetIsLayersOn: 'SetIsLayersOn',
    SetIsPointOfInterestOn: 'SetIsPointOfInterestOn',
    SetIsQueryingOn: 'SetIsQueryingOn',
    SetLayers: 'SetLayers',
    SetQueryLayer: 'SetQueryLayer',
    SetPointCoordinates: 'SetPointCoordinates',
    SetSalesSelectedLayers: 'SetSalesSelectedLayers',
    SetSelectedFootprintFilters: 'SetSelectedFootprintFilters',
    SetSelectedLayers: 'SetSelectedLayers',
    SetSelectedMarkerInfo: 'SetSelectedMarkerInfo',
    SetQueryablePointInfo: 'SetQueryablePointInfo',
    ToggleIsQueryingOn: 'ToggleIsQueryingOn',
  },
  Name: 'salesLayersStore',
  StateVars: {
    FootprintFilters: 'FootprintFilters',
    FootprintMapBoundingBox: 'FootprintMapBoundingBox',
    IsFootprintsLoading: 'IsFootprintsLoading',
    IsLayersOn: 'IsLayersOn',
    IsPointOfInterestOn: 'IsPointOfInterestOn',
    IsQueryingOn: 'isQueryingOn',
    Layers: 'layers',
    PointCoordinates: 'pointCoordinates',
    QueryablePointInfo: 'QueryablePointInfo',
    QueryLayer: 'queryLayer',
    SalesSelectedLayers: 'SalesSelectedLayers',
    SelectedFootprintFilters: 'SelectedFootprintFilters',
    SelectedLayers: 'SelectedLayers',
    SelectedMarkerInfo: 'SelectedMarkerInfo',
  },
};

export const SalesPublicationsStore = {
  Getters: {
    Notification: 'Notification',
  },
  Mutations: {
    SetNotification: 'SetNotification',
  },
  Name: 'salesPublicationsStore',
  StateVars: {
    Notification: 'Notification',
  },
};

export const SalesReportStore = {
  Actions: {
    LoadCompetitorTravelBands: 'LoadCompetitorTravelBands',
    LoadCompetitorData: 'LoadCompetitorData',
    LoadFootprintsData: 'LoadFootprintsData',
    LoadPaperCounts: 'LoadPaperCounts',
    LoadSuburbData: 'LoadSuburbData',
  },
  Getters: {
    BandSize: 'BandSize',
    SuburbData: 'SuburbData',
    CompetitorData: 'CompetitorData',
    FootPrintData: 'FootPrintData',
    IsLoadingCompetitors: 'IsLoadingCompetitors',
    IsLoadingFootprints: 'IsLoadingFootprints',
    IsLoadingPaperCounts: 'IsLoadingPaperCounts',
    IsLoadingSuburbs: 'IsLoadingSuburbs',
    Notification: 'Notification',
    PaperCountData: 'PaperCountData',
    PointsOfInterest: 'PointsOfInterest',
    ReportTypes: 'ReportTypes',
    SelectedFootprint: 'SelectedFootprint',
    SelectedReport: 'SelectedReport',
    TravelBands: 'TravelBands',
  },
  Mutations: {
    SetBandSize: 'SetBandSize',
    SetCompetitorData: 'SetCompetitorData',
    SetFootPrintData: 'SetFootPrintData',
    SetIsLoadingCompetitors: 'SetIsLoadingCompetitors',
    SetIsLoadingFootprints: 'SetIsLoadingFootprints',
    SetIsLoadingPaperCounts: 'SetIsLoadingPaperCounts',
    SetIsLoadingSuburbs: 'SetIsLoadingSuburbs',
    SetNotification: 'SetNotification',
    SetPaperCountData: 'SetPaperCountData',
    SetPointsOfInterest: 'SetPointsOfInterest',
    SetSelectedFootprint: 'SetSelectedFootprint',
    SetSelectedReport: 'SetSelectedReport',
    SetSuburbData: 'SetSuburbData',
    SetTravelBands: 'SetTravelBands',
  },
  Name: 'salesReportStore',
  StateVars: {
    BandSize: 'BandSize',
    CompetitorData: 'CompetitorData',
    FootPrintData: 'FootPrintData',
    IsLoadingCompetitors: 'IsLoadingCompetitors',
    IsLoadingFootprints: 'IsLoadingFootprints',
    IsLoadingPaperCounts: 'IsLoadingPaperCounts',
    IsLoadingSuburbs: 'IsLoadingSuburbs',
    Notification: 'Notification',
    PaperCountData: 'PaperCountData',
    PointsOfInterest: 'PointsOfInterest',
    ReportTypes: 'ReportTypes',
    SelectedFootprint: 'SelectedFootprint',
    SelectedReport: 'SelectedReport',
    SuburbData: 'SuburbData',
    TravelBands: 'TravelBands',
  },
};

export const SoldPublicationFormConfirmationLetterStore = {
  Getters: {
    IsDownloading: 'IsDownloading',
  },
  Mutations: {
    SetIsDownloading: 'SetIsDownloading',
  },
  Name: 'soldPublicationFormConfirmationLetterStore',
  StateVars: {
    IsDownloading: 'IsDownloading',
  },
};

export const SoldPublicationFormImageStore = {
  Actions: {
    UploadFile: 'UploadFile',
  },
  Name: 'soldPublicationFormImageStore',
};

export const MapLayersStore = {
  Actions: {
    LoadJsonLayers: 'LoadJsonLayers',
    QueryByCoordinate: 'QueryByCoordinate',
  },
  Getters: {
    IsQueryingOn: 'IsQueryingOn',
    Layers: 'Layers',
    QueryLayer: 'QueryLayer',
    PointCoordinates: 'PointCoordinates',
    SelectedJsonValues: 'SelectedJsonValues',
    SelectedLayers: 'SelectedLayers',
    SelectedMarkerInfo: 'SelectedMarkerInfo',
    VariabledLayersKey: 'VariabledLayersKey',
  },
  Mutations: {
    ToggleIsQueryingOn: 'ToggleIsQueryingOn',
    SetIsQueryingOn: 'SetIsQueryingOn',
    SetLayers: 'SetLayers',
    SetQueryLayer: 'SetQueryLayer',
    SetPointCoordinates: 'SetPointCoordinates',
    SetSelectedJsonValues: 'SetSelectedJsonValues',
    SetSelectedLayers: 'SetSelectedLayers',
    SetSelectedMarkerInfo: 'SetSelectedMarkerInfo',
    SetVariabledLayersKey: 'SetVariabledLayersKey',
  },
  Name: 'mapLayersStore',
  StateVars: {
    IsQueryingOn: 'isQueryingOn',
    Layers: 'layers',
    PointCoordinates: 'pointCoordinates',
    QueryLayer: 'queryLayer',
    SelectedJsonValues: 'selectedJsonValues',
    SelectedLayers: 'selectedLayers',
    SelectedMarkerInfo: 'SelectedMarkerInfo',
    VariabledLayersKey: 'VariabledLayersKey',
  },
};

export const MapLayersInfoStore = {
  Name: 'mapLayersInfoStore',
};

export const MenuStore = {
  Name: 'menuStore',
  Getters: {
    Parents: 'Parents',
  },
};

export const PayloadParameterRequired = {
  Message: '"payload" Parameter is required.',
};

export const MovementTypesStore = {
  Name: 'movementTypesStore',
};

export const PointCategorizationStore = {
  Name: 'pointCategorizationStore',
};

export const PublicationAccountsStore = {
  Getters: {
    AccountTypesLookup: 'AccountTypesLookup',
    BranchesLookup: 'BranchesLookup',
    FilterForAccountType: 'FilterForAccountType',
    FilterForBranches: 'FilterForBranches',
  },
  Mutations: {
    SetAccountTypesLookup: 'SetAccountTypesLookup',
    SetBranchesLookup: 'SetBranchesLookup',
    SetFilterForAccountType: 'SetFilterForAccountType',
    SetFilterForBranches: 'SetFilterForBranches',
  },
  Name: 'publicationAccountsStore',
  StateVars: {
    AccountTypesLookup: 'AccountTypesLookup',
    BranchesLookup: 'BranchesLookup',
    FilterForAccountType: 'FilterForAccountType',
    FilterForBranches: 'FilterForBranches',
  },
};

export const PublicationMovementsStore = {
  Name: 'publicationMovementsStore',
};

export const PublicationPriceCodeStore = {
  Getters: {
    FilterForPublication: 'FilterForPublication',
    FilterForPriceCode: 'FilterForPriceCode',
  },
  Mutations: {
    SetFilterForPublication: 'SetFilterForPublication',
    SetFilterForPriceCode: 'SetFilterForPriceCode',
  },
  Name: 'publicationPriceCodeStore',
  StateVars: {
    FilterForPublication: 'FilterForPublication',
    FilterForPriceCode: 'FilterForPriceCode',
  },
};

export const publicationTypesStore = {
  Name: 'publicationTypesStore',
};

export const PublicationsStore = {
  Getters: {
    FilterForBranch: 'FilterForBranch',
    FilterForDistributionCentre: 'FilterForDistributionCentre',
    FilterForType: 'FilterForType',
    FilterForPublicationType: 'FilterForPublicationType',
    PublicationDays: 'PublicationDays',
    Types: 'Types',
    FootprintLinkedData: 'FootprintLinkedData',
  },
  Mutations: {
    SetPublicationTypesLookup: 'SetPublicationTypesLookup',
    SetBranchLookup: 'SetBranchLookup',
    SetDistributionCentreLookup: 'SetDistributionCentreLookup',
    SetFilterForBranch: 'SetFilterForBranch',
    SetFilterForDistributionCentre: 'SetFilterForDistributionCentre',
    SetFilterForPublicationType: 'SetFilterForPublicationType',
    SetFilterForType: 'SetFilterForType',
  },
  Name: 'publicationsStore',
  StateVars: {
    BranchLookup: 'BranchLookup',
    DistributionCentreLookup: 'DistributionCentreLookup',
    FilterForBranch: 'FilterForBranch',
    FilterForDistributionCentre: 'FilterForDistributionCentre',
    PublicationDays: 'PublicationDays',
    PublicationTypesLookup: 'PublicationTypesLookup',
    FilterForPublicationType: 'FilterForPublicationType',
    Types: 'Types',
  },
};

export const PriceCodesStore = {
  Name: 'priceCodesStore',
};

export const ReportBulkFreePublicationDropsheetsStore = {
  Actions: {
    FetchBulkFreePublicationDropsheet: 'FetchBulkFreePublicationDropsheet',
  },
  Name: 'ReportBulkFreePublicationDropsheetsStore',
};

export const ReportFootprintStore = {
  Getters: {
    CanPrint: 'CanPrint',
  },
  Name: 'reportFootprintStore',
};

export const ReportFreePublicationDropsheetStore = {
  Name: 'reportFreePublicationDropsheetStore',
};

export const ReportSoldPublicationDropsheetStore = {
  Actions: {
    FetchSoldPublicationDropsheet: 'FetchSoldPublicationDropsheet',
  },
  Getters: {
    CanPrint: 'CanPrint',
  },
  Name: 'reportSoldPublicationDropsheetStore',
};

export const ReportSoldPublicationMovementsStore = {
  Actions: {
    FetchSoldPublicationsMovement: 'FetchSoldPublicationsMovement',
  },
  Getters: {
    ExportMessage: 'ExportMessage',
  },
  Mutations: {
    ExportMessage: 'SetExportMessage',
  },
  Name: 'reportSoldPublicationMovementsStore',
  StateVars: {
    ExportMessage: 'ExportMessage',
  },
};

export const RolesStore = {
  Getters: {
    Disctionary: 'Disctionary',
    FilterForRole: 'FilterForRole',
    SystemRoles: 'SystemRoles',
  },
  Mutations: { SetFilterForRole: 'SetFilterForRole' },
  Name: 'rolesStore',
  StateVars: {
    FilterForRole: 'FilterForRole',
  },
};

export const RouteStore = {
  Name: 'routesStore',
};

export const RunnersStore = {
  Getters: {
    FilterForDriver: 'FilterForDriver',
  },
  Mutations: {
    SetFilterForDriver: 'SetFilterForDriver',
    SetDriverLookup: 'SetDriverLookup',
  },
  StateVars: {
    DriverLookup: 'DriverLookup',
    FilterForDriver: 'FilterForDriver',
  },
  Name: 'runnersStore',
};

export const SecurityTypesStore = {
  Name: 'securityTypesStore',
};

export const SoldPublicationFormStatusStore = {
  Name: 'soldPublicationFormStatusStore',
};

export const SoldPublicationInstanceMovementsStore = {
  Name: 'soldPublicationInstanceMovementsStore',
};

export const SoldPublicationInstancesStore = {
  Actions: {
    LoadDetails: 'LoadDetails',
  },
  Getters: {
    Details: 'Details',
    FilterForPublication: 'FilterForPublication',
    FilterForStartDate: 'FilterForStartDate',
    FilterForEndDate: 'FilterForEndDate',
  },
  Mutations: {
    SetDetails: 'SetDetails',
    SetFilterForPublication: 'SetFilterForPublication',
    SetPublicationLookup: 'SetPublicationLookup',
    SetFilterForStartDate: 'SetFilterForStartDate',
    SetStartDateLookup: 'SetStartDateLookup',
    SetFilterForEndDate: 'SetFilterForEndDate',
    SetEndDateLookup: 'SetEndDateLookup',
  },
  Name: 'soldPublicationInstancesStore',
  StateVars: {
    Details: 'Details',
    PublicationLookup: 'publicationLookup',
    FilterForPublication: 'filterForPublication',
    StartDateLookup: 'startDateLookup',
    EndDateLookup: 'endDateLookup',
    FilterForStartDate: 'filterForStartDate',
    FilterForEndDate: 'filterForEndDate',
  },
};

export const SoldPublicationsFormsStore = {
  Actions: {
    Capture: 'Capture',
    LoadByAttributes: 'LoadByAttributes',
    LoadDetails: 'LoadDetails',
    LoadDetailsByFormId: 'LoadDetailsByFormId',
    LoadFromDate: 'LoadFromDate',
    LoadToDate: 'LoadToDate',
    LoadLookups: 'LoadLookups',
    DownLoadExcel: 'DownLoadExcel',
  },
  Getters: {
    CreatedId: 'CreatedId',
    Details: 'Details',
    FromDate: 'FromDate',
    ToDate: 'ToDate',
    IsDetailsLoading: 'IsDetailsLoading',
    FilterForStatusType: 'FilterForStatusType',
    Lookups: 'Lookups',
    LastSearchedPayload: 'LastSearchedPayload',
    DownloadMessage: 'DownloadMessage',
    ReloadLayers: 'ReloadLayers',
  },
  Mutations: {
    SetCreatedId: 'SetCreatedId',
    SetDetails: 'SetDetails',
    SetFilterForStatusType: 'SetFilterForStatusType',
    SetFilterForStatusTypeLookup: 'SetFilterForStatusTypeLookup',
    SetLookups: 'SetLookups',
    SetIsDetailsLoading: 'SetIsDetailsLoading',
    SetFromDate: 'SetFromDate',
    SetToDate: 'SetToDate',
    SetLastSearchedPayload: 'SetLastSearchedPayload',
    SetDownloadMessage: 'SetDownloadMessage',
    SetReloadLayers: 'SetReloadLayers',
  },
  Name: 'soldPublicationsFormsStore',
  StateVars: {
    CreatedId: 'createdId',
    Details: 'Details',
    FromDate: 'FromDate',
    ToDate: 'ToDate',
    Lookups: 'Lookups',
    FilterForStatusType: 'filterForStatusType',
    LastSearchedPayload: 'LastSearchedPayload',
    StatusTypeLookup: 'statusTypeLookup',
    IsDetailsLoading: 'isDetailsLoading',
    ReloadLayers: 'ReloadLayers',
    DownloadMessage: 'DownloadMessage',
  },
};

export const SoldPublicationsDeliveriesOrReturnsStore = {
  Actions: {
    LoadDetails: 'LoadDetails',
  },
  Getters: {
    Details: 'Details',
  },
  Mutations: {
    SetDetails: 'SetDetails',
  },
  Name: 'soldPublicationsDeliveriesOrReturnsStore',
  StateVars: {
    Details: 'Details',
  },
};

export const SoldPublicationFormHistoryAuditStore = {
  Getters: {
    LoadSource: 'LoadSource',
  },
  Mutations: {
    CancelLoadSource: 'CancelLoadSource',
    SetLoadSource: 'SetLoadSource',
  },
  Name: 'soldPublicationFormHistoryAuditStore',
  StateVars: {
    LoadSource: 'loadSource',
  },
};

export const SoldPublicationPublishEntryStore = {
  Name: 'soldPublicationPublishEntryStore',
};

export const TownsStore = {
  Actions: {
    LoadTowns: 'LoadTowns',
  },
  Name: 'townsStore',
};

export const UsersStore = {
  Actions: {
    ToggleStatus: 'ToggleStatus',
  },
  Getters: {},
  Mutations: {},
  Name: 'usersStore',
};

export const UsersStatusStore = {
  Getters: {
    FilterForStatus: 'FilterForStatus',
  },
  Mutations: { SetFilterForStatus: 'SetFilterForStatus' },
  Name: 'usersStatusStore',
  StateVars: {
    FilterForStatus: 'FilterForStatus',
  },
};

export const WebLoginAuditsStore = {
  Name: 'webLoginAuditsStore',
};

export const DEFAULT_CUSTOM_PUBLICATION_ID = 198;

export const SALES_REPORT_IDS = {
  FOOTPRINT_MAP: 'sales_report:footprint_map',
  FOOTPRINT_DATA: 'sales_report:footprint_data',
  FOOTPRINT_SUBURB_DATA: 'sales_report:suburb_data',
  COMPETITOR_MAP: 'sales_report:competitor_map',
  COMPETITOR_DATA: 'sales_report:competitor_data',
};

export const LAYER_IDS = {
  AFRIGIS_SUBURB: 'zaf:zaf_adm_sublocality_enterprise',
  AFRIGIS_GATED_COMM: 'zaf:zaf_gatedcommunity_enterprise',
  AFRIGIS_POINT_OF_INTEREST: 'zaf:zaf_point_of_interest_enterprise',

  CAXTON_OFFICES: 'caxton:offices',
  CAXTON_DRIVER_AREAS: 'caxton:driver_areas',
  CAXTON_FOOTPRINTS: 'caxton:footprints',

  COMPLAINTS_PENDING: 'caxton:complaints_c_pending',
  COMPLAINTS_RESOLVED: 'caxton:complaints_c_resolved',

  CUSTOM_POINT_BEAUTY: 'caxton:caxton_custompoint_beauty',
  CUSTOM_POINT_CHECKERS: 'caxton:caxton_custompoint_checkers',
  CUSTOM_POINT_LETABA_BUSINESSES: 'caxton:caxton_custompoint_letaba_businesses',
  CUSTOM_POINT_SHOPRIGHT: 'caxton:caxton_custompoint_shoprite',
  CUSTOM_POINT_SHOPRIGHT_LOCATION: 'caxton:caxton_custompoint_shoprite_location',
  CUSTOM_POINT_SHOPRIGHT_MINI: 'caxton:caxton_custompoint_shoprite_mini',
  CUSTOM_POINT_SHOPRIGHT_U_SAVE: 'caxton:caxton_custompoint_shoprite_usave',

  CUSTOMER_SALES_POINT: 'caxton:customer_sales_point',

  FREE_PUB_FORM_CURRENT: 'caxton:free_publications_fp_current',
  FREE_PUB_FORM_REJECTED: 'caxton:free_publications_fp_rejected',
  FREE_PUB_FORM_PENDING: 'caxton:free_publications_fp_pending',
  FREE_PUB_FORM_POTENTIAL: 'caxton:free_publications_fp_potential',

  SOLD_PUB_FORM_CURRENT: 'caxton:sold_publications_sp_current',
  SOLD_PUB_FORM_REJECTED: 'caxton:sold_publications_sp_rejected',
  SOLD_PUB_FORM_PENDING: 'caxton:sold_publications_sp_pending',
  SOLD_PUB_FORM_POTENTIAL: 'caxton:sold_publications_sp_potential',
};
